import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';

import CreateModal from '../Create/Modal';

export default function Filters({ keyword, setKeyword }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <form className="inviteSearch_form">
            <input
              type="text"
              placeholder="Search Affiliate"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>

        <Col md={9} className="text-right">
          <Button
            onClick={() => setShowModal(true)}
            bsStyle="primary"
          >
            Add Affiliate
          </Button>
        </Col>
      </Row>

      <CreateModal show={showModal} onHide={() => setShowModal(false)} />
    </div>
  );
}

Filters.propTypes = {
  keyword: PropTypes.string.isRequired,
  setKeyword: PropTypes.func.isRequired,
};
